import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppRoutes } from '@gfe/app.paths';
import { TransformerInterface } from '@gfe/core/models/entities/entity-visualization-interface';
import { EntityLabelsTranslationService } from '@gfe/core/services/entity-labels-translation/entity-labels-translation.service';
import { UploadClicked } from '@gfe/shared/components/upload-zone/upload-zone.component';
import { FileTransferService } from '@gfe/shared/services/file-transfer/file-transfer.service';

@Injectable()
export class UploadEntitiesFileService {
  private readonly fileTransferService = inject(FileTransferService);
  private readonly entityLabelsTranslationService = inject(EntityLabelsTranslationService);
  private readonly router = inject(Router);

  processFilesDropped(
    event: UploadClicked,
    transformers: TransformerInterface[],
    activatedRoute: ActivatedRoute
  ): void {
    const files = event.files;
    const translatedTransformerName = event.transformer;
    const transformer = transformers.find((t) => {
      const rawName = t.transformerDisplayLabel();
      return (
        translatedTransformerName ===
        this.entityLabelsTranslationService.translateCsvTransformerName(rawName)
      );
    });
    const transformerName = transformer?.transformerDisplayLabel();
    this.fileTransferService.setFiles(files);
    this.router.navigate([AppRoutes.data.dataUpload], {
      relativeTo: activatedRoute,
      queryParams: { transformer: transformerName },
      queryParamsHandling: 'merge'
    });
  }
}
